export default {
  result: null,
  loading: false,
  productGroupId: null,
  orderBy: 'CreatedDesc',
  search: false,
  searchCriteria: null,
  highlights: false,
  isSearched: false
}